export const BUSINESS = {
  name: 'Taller Automotriz Autoscan Plus',
  telephone: '573232029381',
  nit: '900000000-1',
  shortName: 'Autoscan Plus',
  login: {
    eyebrow: 'Plataforma interna',
    accessTitle: 'Acceso privado',
    accessSubtitle:
      'Ingresa tus credenciales para acceder.',
    logoAlt: 'Logo de Taller Automotriz Autoscan Plus',
    logoPath: '/logos/logo_auto_scan_plus.webp',
    logoPathSmall: '/logos/logo_auto_scan_plus-convertido-a-pequeño.png',
  },
} as const;
